"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseStudiesSearchResult = exports.CaseStudiesDocumentList = exports.CaseStudiesDocument = exports.CaseStudiesDataService = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var json2typescript_1 = require("json2typescript");
var search_1 = require("src/search");
var taxonomy_1 = require("src/taxonomy");
var FilterableDataService_1 = require("Views/Partials/Components/FilterableList/FilterableDataService");
var CaseStudiesDataService = /** @class */ (function (_super) {
    tslib_1.__extends(CaseStudiesDataService, _super);
    function CaseStudiesDataService(config) {
        var _this = _super.call(this, config) || this;
        // Get group filter information like type, sort order, ...
        _this.groupFilterTemplates = app_1.TaxonomyService.getGroupFilterTemplateByType(config.type);
        _this.groupFilterTemplates = _this.groupFilterTemplates.map(function (filterGroup) {
            if (filterGroup.type === taxonomy_1.TaxonomyTypeEnum.SegmentsTaxonomy) {
                return filterGroup;
            }
            return tslib_1.__assign(tslib_1.__assign({}, filterGroup), { isCollapsed: true });
        });
        // Create Search Api instance with specific type
        _this.searchApi = new search_1.FacetedSearchApi({
            url: _this.config.searchUrl,
        });
        // Set up dayjs library with current language
        app_1.DateService.setLocale(config.culture);
        return _this;
    }
    CaseStudiesDataService.prototype.loadData = function (facetParams, classReference) {
        if (classReference === void 0) { classReference = CaseStudiesSearchResult; }
        // Set class reference to CaseStudiesSearchResult to be able convert json to this class and make instance
        return _super.prototype.loadData.call(this, facetParams, classReference);
    };
    // extended from base classes
    CaseStudiesDataService.prototype.buildSearchApiParams = function (params) {
        // Added for supporting double encoded filter items in link
        var decodedFilters = search_1.decodeFilters(params.filters);
        var result = {
            filters: decodedFilters,
            locale: this.config.culture,
            sort: params.sort,
        };
        result.pageSize = this.getPageHits(params.pageSize);
        result.hits = this.getPageHits(params.pageSize);
        result.offset = this.getPageOffset(params.page, params.pageSize);
        result.itemTypes = [search_1.FilterItemTypesEnum.CaseStudyPage];
        return result;
    };
    // extended from base classes
    CaseStudiesDataService.prototype.buildTaxonomyApiParams = function (pageId) {
        var result = _super.prototype.buildTaxonomyApiParams.call(this, pageId);
        result.taxonomyAliases = app_1.TaxonomyService.convertToTaxonomyAliases(this.groupFilterTemplates).join(',');
        return result;
    };
    // extended from base classes
    CaseStudiesDataService.prototype.filterGroupTaxonomy = function (taxonomy) {
        var result = _super.prototype.filterGroupTaxonomy.call(this, taxonomy);
        // Added custom filtering logic
        if (result) {
            result = taxonomy.customerFacing;
        }
        return result;
    };
    // extended from base classes
    CaseStudiesDataService.prototype.createTileListItem = function (item) {
        var result = _super.prototype.createTileListItem.call(this, item);
        result.title = item.title;
        result.description = item.description;
        result.image = item.image;
        result.imageAltText = item.imageAltText;
        result.link = { url: item.path };
        result.formattedStartDate = app_1.capitalizeFirstLetter(app_1.DateService.formatDate(item.startDate || item.start_date));
        return result;
    };
    return CaseStudiesDataService;
}(FilterableDataService_1.FilterableDataService));
exports.CaseStudiesDataService = CaseStudiesDataService;
/* tslint:disable */
var CaseStudiesDocument = /** @class */ (function (_super) {
    tslib_1.__extends(CaseStudiesDocument, _super);
    function CaseStudiesDocument() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.applications = undefined;
        _this.int_products = undefined;
        _this.markets = undefined;
        _this['int_sub-segments'] = undefined;
        _this.solutions = undefined;
        _this.start_date = undefined;
        _this.startDate = undefined;
        return _this;
    }
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('applications', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], CaseStudiesDocument.prototype, "applications", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('int_products', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], CaseStudiesDocument.prototype, "int_products", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('markets', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], CaseStudiesDocument.prototype, "markets", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('int_sub-segments', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], CaseStudiesDocument.prototype, "int_sub-segments", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('solutions', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], CaseStudiesDocument.prototype, "solutions", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('start_date', String, true),
        tslib_1.__metadata("design:type", String)
    ], CaseStudiesDocument.prototype, "start_date", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('startDate', Number, true),
        tslib_1.__metadata("design:type", Number)
    ], CaseStudiesDocument.prototype, "startDate", void 0);
    CaseStudiesDocument = tslib_1.__decorate([
        json2typescript_1.JsonObject('CaseStudiesDocument')
    ], CaseStudiesDocument);
    return CaseStudiesDocument;
}(search_1.FacetedDocumentBase));
exports.CaseStudiesDocument = CaseStudiesDocument;
var CaseStudiesDocumentList = /** @class */ (function (_super) {
    tslib_1.__extends(CaseStudiesDocumentList, _super);
    function CaseStudiesDocumentList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.documents = undefined;
        return _this;
    }
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('documents', [CaseStudiesDocument]),
        tslib_1.__metadata("design:type", Array)
    ], CaseStudiesDocumentList.prototype, "documents", void 0);
    CaseStudiesDocumentList = tslib_1.__decorate([
        json2typescript_1.JsonObject('CaseStudiesDocumentList')
    ], CaseStudiesDocumentList);
    return CaseStudiesDocumentList;
}(search_1.DocumentListBase));
exports.CaseStudiesDocumentList = CaseStudiesDocumentList;
var CaseStudiesSearchResult = /** @class */ (function (_super) {
    tslib_1.__extends(CaseStudiesSearchResult, _super);
    function CaseStudiesSearchResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.documentList = undefined;
        return _this;
    }
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('documentList', CaseStudiesDocumentList),
        tslib_1.__metadata("design:type", CaseStudiesDocumentList)
    ], CaseStudiesSearchResult.prototype, "documentList", void 0);
    CaseStudiesSearchResult = tslib_1.__decorate([
        json2typescript_1.JsonObject('CaseStudiesSearchResult')
    ], CaseStudiesSearchResult);
    return CaseStudiesSearchResult;
}(search_1.SearchResultBase));
exports.CaseStudiesSearchResult = CaseStudiesSearchResult;
/* tslint:enable */
